import { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { useContent } from "contexts/contentContext/contentContext.js";
import useMediaQueries from "hooks/useMediaQueries.js";
import { useUploader } from "contexts/uploaderContext/uploaderContext.js";

const VideoPreviewModal = ({
  preview,
  hover,
  fileType,
  fileRef,
  middleTop,
}) => {
  const { getDirection } = useContent();
  const { mobileCondition } = useMediaQueries();
  const { getUploading } = useUploader();
  const videoPreviewContainer =
    document.querySelector(".video-preview-modal-portal") ||
    document.createElement("div");
  videoPreviewContainer.className = "video-preview-modal-portal";
  document.body.appendChild(videoPreviewContainer);

  const [position, setPosition] = useState(null);
  const [aspectRatio, setAspectRatio] = useState(0);

  useEffect(() => {
    if (!fileRef.current) return;
    const { top, left, width, height } =
      fileRef.current?.getBoundingClientRect();
    const videoWidth = aspectRatio > 1 ? aspectRatio * 180 + 5 : 180;
    const xPosition =
      getDirection() === "ltr" ? left + width + 5 : left - videoWidth;
    // detect if x position is close to the screen edge
    const xPositionAdjusted =
      getDirection() === "ltr"
        ? xPosition + videoWidth > window.innerWidth
          ? xPosition - videoWidth - width - 5
          : xPosition
        : xPosition <= 0
        ? xPosition + videoWidth + width + 5
        : xPosition;

    const topPosition = middleTop ? top + height / 2 - 90 : top;

    setPosition({
      top: topPosition + window.scrollY,
      left: xPositionAdjusted,
    });
  }, [hover, aspectRatio]);

  useEffect(() => {
    if (preview) {
      const videoElement = document.createElement("video");
      videoElement.src = preview;
      videoElement.addEventListener("loadedmetadata", () => {
        const aspectRatio = videoElement.videoWidth / videoElement.videoHeight;
        setAspectRatio(aspectRatio);
      });
    }
  }, [preview]);

  return null;

  return !mobileCondition &&
    !getUploading() &&
    hover &&
    preview &&
    fileType.includes("video") &&
    position
    ? ReactDOM.createPortal(
        <div
          className={`video-preview-modal ${getDirection()}`}
          style={position}
        >
          <video
            width={aspectRatio > 1 ? aspectRatio * 180 + "px" : "180px"}
            height={aspectRatio > 1 ? "180px" : 180 / aspectRatio + "px"}
            controls={false}
            autoPlay
            muted
          >
            <source src={preview} type="video/mp4" />
          </video>
        </div>,
        videoPreviewContainer
      )
    : null;
};
export default VideoPreviewModal;
